import { Component } from '@angular/core';
import { AppConfig } from 'src/app/configs/app.config';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  //----------------------------  Constant  --------------------------------//
  readonly AppConfig = AppConfig;
}
